import { SpotlightTour } from "components/ProductAnnouncement/SpotlightTour";
import { useProductAnnouncement } from "components/ProductAnnouncement/useProductAnnouncement";
import { ProductAnnouncementKey } from "generated-graphql/graphql";
import { useCallback } from "react";

import {
  SCOUT_LAUNCH_TOUR_STEPS,
  SCOUT_LAUNCH_URL,
  SCOUT_NAV_ANCHOR_ID,
} from "./scoutLaunchAnnouncementConfig";
import { ScoutLaunchAnnouncementModal } from "./ScoutLaunchAnnouncementModal";

export function ScoutLaunchAnnouncement() {
  const {
    phase,
    dismissModal,
    softDismissModal,
    dontShowAgain,
    setDontShowAgain,
    clickSecondaryCta,
    startTour,
    completeTour,
    dismissTour,
    viewTourStep,
  } = useProductAnnouncement(ProductAnnouncementKey.ScoutLaunch_2026_07);

  const handleLearnMore = useCallback(() => {
    window.open(SCOUT_LAUNCH_URL, "_blank", "noopener,noreferrer");
    // Keep the modal open so the user can return and still start the tour.
    clickSecondaryCta();
  }, [clickSecondaryCta]);

  return (
    <>
      <ScoutLaunchAnnouncementModal
        open={phase === "modal"}
        onDismiss={dismissModal}
        onSoftDismiss={softDismissModal}
        dontShowAgain={dontShowAgain}
        onDontShowAgainChange={setDontShowAgain}
        onLearnMore={handleLearnMore}
        onStartTour={startTour}
      />
      {phase === "tour" ? (
        <SpotlightTour
          steps={SCOUT_LAUNCH_TOUR_STEPS}
          onDismiss={dismissTour}
          onComplete={completeTour}
          onStepViewed={viewTourStep}
          mobileNavAnchorId={SCOUT_NAV_ANCHOR_ID}
        />
      ) : null}
    </>
  );
}
